module.exports = __webpack_public_path__ + "images/4_NOON_Three_Gang.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/4_NOON_Three_Gang.png
// module id = 261
// module chunks = 0